import React, { FunctionComponent, Fragment } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { formattedPriceRangeEDP } from 'src/lib/formatter'

const style = require('./Price.css')
import locale from '../locale'

interface Props {
  minPrice: number,
  maxPrice: number,
  currency: string,
  listingStatus: string,
}


const PriceComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  minPrice,
  maxPrice,
  currency,
  listingStatus,
  intl
}) => {
  const priceRange = formattedPriceRangeEDP({ minPrice, maxPrice, currency, intl })

  const determinePriceDisplay = () => {
    return priceRange.length === 1 ?
      <div className={style.priceRange}>{priceRange[0]}</div> :
      <Fragment>
        <div className={style.priceRange}>{priceRange[0]}</div>
        <div className={style.priceRange}>- {priceRange[1]}</div>
      </Fragment>
  }

  const priceDisplay = () => {
    switch (listingStatus) {
      case "noData":
        return null;
      case "soldoutWaitlistEnabled":
      case "soldoutWaitlistNotEnabled":
        return <div>{intl.formatMessage(locale.eventSoldOut)}</div>;
      case "semiAvailableNotStarted":
      case "semiAvailableAllLocked":
        return null;
      case "salesEnded":
      case "salesEndedEventOver":
        return <div>{intl.formatMessage(locale.eventEnded)}</div>;
      case "unavailableAllHidden":
      case "unavailableOnlyAtDoor":
      case "unavailableHiddenNoWaitlist":
        return <div>{intl.formatMessage(locale.eventUnavailable)}</div>;
      case "unavailableGeofenced":
        return <div>{intl.formatMessage(locale.eventUnavailableGeofenced)}</div>;
      case "availableStandard":
        return determinePriceDisplay();
    }
  }

  const price = priceDisplay()
  const getPriceClass = (minPrice: number) => `${style.container} ${(minPrice === 0) ? style.free : ''} ${listingStatus !== 'availableStandard' ? style.notAvailable : ''}`

  return (
    price && <div className={getPriceClass(minPrice)}>
      {price}
    </div>
  )
}

export const Price = injectIntl(PriceComponent)
